import enLocale from 'element-ui/lib/locale/lang/en';
import ruLocale from 'element-ui/lib/locale/lang/ru-RU';
import ukLocale from 'element-ui/lib/locale/lang/ua';
import ptLocale from 'element-ui/lib/locale/lang/pt';
import azLocale from 'element-ui/lib/locale/lang/az';

export default {
  en: enLocale,
  ru: ruLocale,
  uk: ukLocale,
  pt: ptLocale,
  az: azLocale,
};
